import { PureComponent } from "react";

import type { IModal } from "@Components/Modal";
import { Modal } from "@Components/Modal";

import type { IInformationContent } from "./InformationContent";
import { InformationContent } from "./InformationContent";

import * as css from "./InformationModal.module.css";

export interface IInformationModal extends IModal {
    content: IInformationContent | null;
}

interface InformationModalState {
    isOpen: boolean;
}

export class InformationModal extends PureComponent<IInformationModal, InformationModalState> {
    constructor(props: IInformationModal) {
        super(props);

        this.state = { isOpen: true };
    }

    public render(): React.ReactNode {
        const modalProps = {
            ...this.props,
            isOpen: this.state.isOpen,
            className: css.informationModalComponent,
            onClose: this.props.onClose,
        };

        const onClick = () => {
            this.setState({ isOpen: false });
        };

        return (
            <Modal {...modalProps}>
                <InformationContent {...this.props.content} onClickButton={onClick} />
            </Modal>
        );
    }
}
